import { createFileRoute } from "@tanstack/react-router";

import { AdminInquiryNotificationSettingsPage } from "@/features/admin/inquiries/notification-settings-page";
import { adminInquiryNotificationEmailsQueryOptions } from "@/features/admin/inquiries/queries";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
// 静的セグメントは動的セグメントより優先されるので、兄弟の `$id`（お問い合わせ詳細）に
// 食われることはない。
export const Route = createFileRoute("/_authenticated/admin/inquiries/notifications")({
  staticData: { crumb: { label: "通知設定" } },
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(adminInquiryNotificationEmailsQueryOptions());
  },
  component: AdminInquiryNotificationSettingsPage,
});
